
import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/UserManageApi/UserManage";
import { validateForm } from "utils/validation";
import { UserAddRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddUserForm from "./Componates/AddUserForm";
import fields from "../json/UserLisrFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const UserAdd = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
    initialValues,
    UserAddRules
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      formData.append("usertype", "1");
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, UserAddRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Create user successfully"
  );

  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddUserForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        title="Create User"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default UserAdd;
